/* The filing spine. Tokens only. A connector line sits between marks and is decoration. */

.spine {
  --spine-ink: var(--ink);
  --spine-muted: var(--muted);
  --spine-line: var(--line-2);
  --spine-done: var(--ok);
  --spine-current: var(--warn);
  --spine-blocked: var(--crit);
  --spine-unknown: var(--info);

  display: flex;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0;
  list-style: none;
  min-width: 0;
  /* Contains the visually hidden state words, which are absolutely positioned: left to the page they
     sit at their static position and can widen the document inside a scrolling table. */
  position: relative;
}

.spine[data-surface="hero"] {
  --spine-ink: var(--hero-ink);
  --spine-muted: var(--hero-muted);
  --spine-line: var(--hero-track);
  --spine-done: var(--hero-ok-ink);
  --spine-current: var(--hero-warn-ink);
  --spine-blocked: var(--hero-crit-ink);
  --spine-unknown: var(--hero-link);
}

.step {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
  color: var(--spine-muted);
}

.mark {
  display: inline-grid;
  place-items: center;
  flex: none;
  color: var(--spine-muted);
}

.step[data-state="done"] .mark {
  color: var(--spine-done);
}

.step[data-state="current"] .mark {
  color: var(--spine-current);
}

.step[data-state="blocked"] .mark {
  color: var(--spine-blocked);
}

.step[data-state="unknown"] .mark {
  color: var(--spine-unknown);
}

/* ---- full: label and a few words, a line running to the next step */

.full {
  gap: 0;
}

/* The mark sits on top and its words under it, so the connector (level with the mark) never runs
   through a word. */
.full .step {
  flex: 1 1 0;
  flex-direction: column;
  gap: 4px;
  padding-right: 10px;
}

.full .step:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 8px;
  left: 26px;
  right: 6px;
  height: 2px;
  border-radius: 2px;
  background: var(--spine-line);
}

.full .step[data-state="done"]:not(:last-child)::after {
  background: var(--spine-done);
}

.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 1px;
}

.label {
  color: var(--spine-ink);
  font-size: var(--t-dense);
  font-weight: 650;
  overflow-wrap: anywhere;
}

.note {
  color: var(--spine-muted);
  font-size: var(--t-min);
  overflow-wrap: anywhere;
}

/* ---- compact: marks only, for a table row */

.compact {
  gap: 2px;
  align-items: center;
}

.compact .step {
  align-items: center;
}

.compact .step:not(:last-child)::after {
  content: "";
  display: block;
  width: 10px;
  height: 2px;
  margin-left: 2px;
  border-radius: 2px;
  background: var(--spine-line);
}

.compact .step[data-state="done"]:not(:last-child)::after {
  background: var(--spine-done);
}

@media (max-width: 720px) {
  .full {
    flex-direction: column;
    gap: 8px;
  }

  /* A list on a phone: the mark beside its words, no connector. */
  .full .step {
    flex-direction: row;
    gap: 8px;
  }

  .full .step:not(:last-child)::after {
    display: none;
  }
}
